import { getSuperVoiceList } from '@/service/generatorv2';
import { useRequest } from 'ahooks';

export const useSuperVoiceList = () => {
  const { data: superVoiceData, loading } = useRequest(getSuperVoiceList);
  const superVoiceList = superVoiceData?.data || [];
  return { superVoiceList, loading };
};
